import React from "react";

import NewPayments from "components/app/home/sections/school_money/NewPayments";
import OverduePayments from "components/app/home/sections/school_money/OverduePayments";
import NewShopItems from "components/app/home/sections/school_money/NewShopItems";

import "./SchoolMoneyHomeSection.css";

/**
 * Delegate to each of the sections for the SM product
 */
export default class SchoolMoneyHomeSection extends React.Component {
  
  render() {
    return (
      <div className="school_money-home">
        <NewPayments />
        <OverduePayments />
        <NewShopItems />
      </div>
    )
  }
  
}



// WEBPACK FOOTER //
// ./src/components/app/home/sections/school_money/SchoolMoneyHomeSection.js